<template>
  <div class="menu-page">
    <div>
      <dashboard-nav></dashboard-nav>
      <div class="d-flex bodyWrapper">
        <div class="nav-view">
          <main-nav></main-nav>
        </div>

        <!-- VIEW START -->
        <div class="main-view" v-if="dataReady">
          <breadcrumb></breadcrumb>
          <div class="intro-wrapper main-x-spacing">
            <h2>{{ title }}</h2>
            <v-row>
              <v-col cols="9">
                <v-text-field
                  v-model="searchQuery"
                  prepend-inner-icon="search"
                  label="Search Devices"
                  class="toWhite"
                  flat
                  hide-details
                  single-line
                  solo
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-btn
                  :ripple="false"
                  depressed
                  class="gen-button white--text flex-grow-1 flex-shrink-0"
                  color="#60a45f"
                  @click="openAddDevices"
                >
                  <v-icon>add</v-icon>
                  <span>Add New Device</span>
                </v-btn>
              </v-col>
              <!-- <v-col cols="2">
                <v-btn
                  :ripple="false"
                  @click="uploadMenu"
                  depressed
                  class="gen-button"
                >
                  <v-icon>backup</v-icon>
                  <span>Upload Menus</span>
                </v-btn>
              </v-col> -->
            </v-row>
          </div>
          <!-- main view -->
          <div class="main-body-content main-x-spacing">
            <v-row v-if="allDevices.length > 0">
              <v-col cols="12">
                <div class="table-menu">
                  <table class="tableUI staffTable">
                    <thead>
                      <tr>
                        <th>Activation Code</th>
                        <th>Location</th>
                        <th>Device Name</th>
                        <th>Type</th>
                        <th>Status</th>
                        <th class="text-center">Action</th>
                      </tr>
                    </thead>
                    <!-- <pre>{{ allDevices }}</pre> -->
                    <tbody>
                      <tr v-for="(device, index) in allDevices" :key="index">
                        <td>{{ device.activationCode }}</td>
                        <td>{{ device.location.locationName }}</td>
                        <td>{{ device.name }}</td>
                        <td>{{ device.deviceType }}</td>
                        <td>
                          <v-switch
                            v-model="device.status"
                            :loading="loader && index == num"
                            @change="
                              switchDeviceStatus(device.id, device.status);
                              num = index;
                            "
                            color="primary"
                            hide-details
                            inset
                            class="ma-0"
                          ></v-switch>
                        </td>
                        <td
                          class="d-flex justify-center align-center justify-space-around py-1"
                        >
                          <v-btn
                            :ripple="false"
                            depressed
                            text
                            class="gen-button btn-outlined no-Btn-bg"
                            @click="
                              editDevice(device);
                              editMode = true;
                            "
                          >
                            <v-icon>edit</v-icon>
                            <span>Edit</span>
                          </v-btn>
                          <span class="mx-1"></span>
                          <v-btn
                            :ripple="false"
                            depressed
                            :loading="deleteLoader && index == num"
                            class="btn-outlined gen-button"
                            @click="
                              deleteDevice(device.id);
                              num = index;
                            "
                          >
                            <v-icon>delete</v-icon>
                            <span>Delete</span>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- {{ allMenu }} -->
                </div>
              </v-col>
            </v-row>

            <div v-else class="responseReady">
              No Device yet. Click <b>Add New Device</b> to get started
            </div>
          </div>
          <!-- Upload List -->
          <v-row justify="center" class="openDialogWrapper">
            <v-dialog
              v-model="openDialog"
              fullscreen
              max-width="50%"
              transition="scroll-x-reverse-transition"
              class="openDialog"
            >
              <v-card
                max-width="50%"
                tile
                class="ml-auto dialogCard"
                height="100%"
              >
                <!-- Add New Device -->
                <div v-if="addNewDeviceActive" class="formLayerCard">
                  <h2 v-if="!editMode" class="dialog-form-title">
                    Add New Device
                  </h2>
                  <h2 v-else class="dialog-form-title">Edit Device</h2>
                  <v-form ref="dialogForm" class="dialog-form">
                    <v-row>
                      <v-col cols="12">
                        <div>Device Name</div>
                        <v-text-field
                          v-model="deviceName"
                          outlined
                          hide-details
                          placeholder="Device Name"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12"
                        ><div><b>Assign to Location</b></div>
                        <v-select
                          v-model="deviceLocation"
                          hide-details
                          outlined
                          :menu-props="{ offsetY: true }"
                          placeholder="Select Location"
                          append-icon="arrow_drop_down"
                          :items="enterpriseLocations"
                          item-text="locationName"
                          item-value="id"
                        ></v-select
                      ></v-col>
                      <v-col cols="12"
                        ><div>Device Type</div>
                        <v-select
                          v-model="deviceType"
                          hide-details
                          outlined
                          :menu-props="{ offsetY: true }"
                          placeholder="Select Device Type"
                          append-icon="arrow_drop_down"
                          :items="deviceTypeOptions"
                          item-text="name"
                          item-value="value"
                        ></v-select
                      ></v-col>
                      <v-col cols="12">
                        <div>Status</div>
                        <v-select
                          v-model="status"
                          class="text-capitalize"
                          hide-details
                          outlined
                          append-icon="arrow_drop_down"
                          :items="[
                            { name: 'active', value: true },
                            { name: 'inactive', value: false },
                          ]"
                          item-text="name"
                          item-value="value"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-form>

                  <div class="dialogAction text-right">
                    <v-btn
                      :ripple="false"
                      @click="openDialog = false"
                      class="grey--text mr-3"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      v-if="addNewDeviceActive && !editMode"
                      :loading="loader"
                      :ripple="false"
                      color="#468346"
                      class="white--text"
                      @click="addEditDevice"
                      >Ok</v-btn
                    >
                    <v-btn
                      v-if="addNewDeviceActive && editMode"
                      :loading="loader"
                      :ripple="false"
                      color="#468346"
                      class="white--text"
                      @click="addEditDevice"
                      >Save</v-btn
                    >
                  </div>
                </div>
              </v-card>
            </v-dialog>
          </v-row>
        </div>
        <inner-page-loader v-else class="main-view"></inner-page-loader>
      </div>
    </div>

    <!-- Snackbar Notification -->
    <v-snackbar
      class="snackbar"
      :color="snackBar.color"
      bottom
      right
      v-model="snackBar.active"
      :multi-line="snackBar.multiLine"
      :timeout="snackBar.timeout"
      >{{ snackBar.text }}</v-snackbar
    >
  </div>
</template>

<script>
import dashboard_Nav from "@/components/dashboard-nav";
import main_Nav from "@/components/mainNav";
import bread_crumb from "@/components/breadcrumb";
import inner_page_loader from "@/components/innerPageLoader";
import { mapState } from "vuex";

import axios from "axios";

export default {
  data() {
    return {
      title: "Devices",
      deleteLoader: false,
      num: -1,
      dataReady: false,
      loader: false,
      currentDevice: {},
      editedDeviceData: {},
      deviceTypeOptions: [
        { name: "Cashier", value: "cashier" },
        { name: "KDS", value: "kds" },
      ],
      editMode: false,
      deviceName: "",
      deviceLocation: "",
      deviceType: "",
      status: "",
      openDialog: false,
      addNewDeviceActive: false,
      rules: {
        required: (value) => !!value || "Required",
        number: (value) => !value || /^[0-9]*$/.test(value) || "Invalid value",
      },
      snackBar: {
        active: false,
        text: "",
        color: "",
        multiLine: "",
        timeout: null,
      },
      allDevicesCopy: this.$store.state.allDevices,
      typing: "",
      searchQuery: "",
    };
  },
  methods: {
    switchDeviceStatus(id, getStatus) {
      //   Start Loader
      this.loader = true;

      // let status = "";
      // getStatus == false ? (status = true) : (status = false);

      axios
        .put(
          "/api/v1/device/" + id,
          { status: getStatus },
          {
            headers: { Authorization: this.$store.state.token },
          }
        )
        .then(() => {
          this.$store.dispatch("getAllDevices");

          this.snackBar.active = true;
          this.snackBar.text = "Status updated successfully";
          this.snackBar.color = "success";
          this.snackBar.timeout = this.$store.state.snackBarDuration;

          //   Stop Loader
          this.loader = false;
        })
        .catch(() => {
          this.snackBar.active = true;
          this.snackBar.text = "Status update failed";
          this.snackBar.color = "error";
          this.snackBar.timeout = this.$store.state.snackBarDuration;

          //   Stop Loader
          this.loader = false;
        });
    },
    deleteDevice(id) {
      this.deleteLoader = true;

      axios
        .delete("/api/v1/device/" + id, {
          headers: { Authorization: this.$store.state.token },
        })
        .then(() => {
          this.$store.dispatch("getAllDevices");

          //   Stop Loader
          this.deleteLoader = false;
        })
        .catch(() => {
          //   Stop Loader
          this.deleteLoader = false;
        });
    },
    editDevice(data) {
      this.addNewDeviceActive = true;
      this.openDialog = true;

      this.currentDevice = data;

      this.deviceName = data.name;
      this.deviceLocation = data.locationId;
      this.deviceType = data.deviceType;
      this.status = data.status;

      // data.status == true
      //   ? (this.status = "active")
      //   : (this.status = "inactive");
    },
    addEditDevice() {
      if (this.$refs.dialogForm.validate()) {
        this.loader = true;

        if (this.editMode == false) {
          axios
            .post(
              "/api/v1/device",
              {
                name: this.deviceName,
                locationId: this.deviceLocation,
                deviceType: this.deviceType,
                status: this.status,
              },
              { headers: { Authorization: this.$store.state.token } }
            )
            .then(() => {
              this.$store.dispatch("getAllDevices");

              this.addNewDeviceActive = false;
              this.openDialog = false;

              //   Stop Loader
              this.loader = false;
            })
            .catch(() => {
              //   Stop Loader
              this.loader = false;
            });
        } else if (this.editMode == true) {
          // if it is edit mode

          this.status == "active"
            ? (this.status = true)
            : (this.status = false);

          axios
            .put(
              "/api/v1/device/" + this.currentDevice.id,
              {
                name: this.deviceName,
                status: this.status,
              },
              { headers: { Authorization: this.$store.state.token } }
            )
            .then(() => {
              this.currentDevice = {}; // VERY IMPORTANT: Always negate data after each edit request
              this.editMode = false; // VERY IMPORTANT: Always negate data after each edit request

              this.$store.dispatch("getAllDevices");

              this.addNewModifierGroupActive = false;
              this.openDialog = false;

              //   Stop Loader
              this.loader = false;
            })
            .catch(() => {
              this.currentDevice = {}; // VERY IMPORTANT: Always negate data after each edit request
              this.editMode = false; // VERY IMPORTANT: Always negate data after each edit request

              this.addNewModifierGroupActive = false;
              this.openDialog = false;

              //   Stop Loader
              this.loader = false;
            });
        }
      }
    },
    openAddDevices(edit, data) {
      if (edit == "editMode") {
        this.editMode = true;

        // Store the Device being edited
        this.editedDeviceData = data;

        this.addNewDeviceActive = true;
        this.openDialog = true;
      } else {
        this.addNewDeviceActive = true;
        this.openDialog = true;
      }
    },
  },
  watch: {
    allDevices(val) {
      if (val) {
        // stop page loader when data is ready
        this.dataReady = true;
      }
    },
    openDialog(val) {
      if (val == false) {
        this.addNewDeviceActive = false;
        this.$refs.dialogForm.reset();
      }
    },
    typing(val) {
      if (val == false) {
        this.searchQuery = "";
      }
    },
    filteredSearchResult(newVal) {
      if (newVal.length < 1) {
        this.noResultFound = true;
      } else if (newVal.length > 0) {
        this.noResultFound = false;
      }
    },
    searchQuery(val) {
      if (val.length > 0) {
        this.typing = true;
      } else {
        this.typing = false;
      }
    },
  },
  created() {
    this.$store.dispatch("getAllDevices");
  },
  computed: {
    filteredSearchResult() {
      // return this.allDevicesCopy.filter((item) => {
      //   if (
      //     item.name.toLowerCase().indexOf(this.searchQuery.toLowerCase()) !== -1
      //   ) {

      //     return item;
      //   }
      // });
      return [];
    },
    ...mapState(["mainNav", "enterpriseLocations", "allDevices"]),
  },
  components: {
    "dashboard-nav": dashboard_Nav,
    "main-nav": main_Nav,
    breadcrumb: bread_crumb,
    "inner-page-loader": inner_page_loader,
  },
};
</script>

<style scoped>
.table-menu {
  width: 96%;
  margin-left: 2%;
  margin-right: 2%;
}
.table-menu .table-col2 {
  width: 40%;
}

.image {
  width: 130px;
}

.item_status_icon {
  color: green;
}
</style>
